import type { Gallery } from "../types/about";
import type { Heading } from "../types/global";

export const aboutHeading: Heading = {
    heading: "About",
    paragraph: "<p>Strangeways Studios didn’t start as a business plan. It began in a shared jam space in Gastown where I’d write and record into the wee hours of the morning. Somewhere around 2008 I started composing music for films in Vancouver, scoring several features, and earning some encouraging accolades along the way.</p><p>Eventually that scrappy setup migrated to Tiger Mountain—a makeshift music venue on Vancouver Island that I co-founded in 2015. It grew into a full recording and rehearsal space and a music school. At its busiest, more than 130 students came through each week, with local bands filling evenings and weekends. Friends like Arlen Thompson of Wolf Parade helped stock the room with consoles and microphones, and before long Wolf Parade were writing and demoing <a href='https://www.youtube.com/watch?v=m9PXuUKG4AA' target='_blank' class='hyperlink-external'>Cry, Cry, Cry</a> in the same space where the young and old from the community were taking their lessons.</p><p>Then 2020 hit. The pandemic emptied the rooms overnight. Lessons moved online, and I threw myself into building a remote learning platform called Riffable.com while recording two albums with a new band, <a href='https://www.musichall.band/' target='_blank' class='hyperlink-external'>Music Hall</a>. It was an immensely creative but draining period. By 2023, I was burnt out enough to put the studio on hiatus and step more fully into software engineering.</p><p>But walking away never stuck. The studio had given me some of the best moments of my life—underground shows, kids racing in after school, late-night sessions where a song finally clicked on the thirtieth take. It introduced me to artists I’d never have met otherwise. So instead of closing the chapter, I chose to return with a clearer sense of what the studio should be.</p><p>Strangeways Studios is that return. The name reaches back to my time living in the northwest of England, riding past the gothic Victorian era Strangeways prison while listening to <a href='https://www.youtube.com/watch?v=ycKOdZUzZBM' target='_blank' class='hyperlink-external'>Strangeways, Here We Come</a>. It’s a word that has become rich in relevance and double-entendre to me.</p><blockquote class='text-xl'><p>And those who were seen dancing were thought to be insane by those who could not hear the music.</p><footer class='text-base'>— Friedrich Nietzsche</footer></blockquote><p>Today, Strangeways is a modern recording studio built around how artists actually work. The room is tuned to be pragmatic while still feeling inspiring. Tracking, mixing, and collaboration are designed to be as turnkey as possible, so ideas don’t get smothered by setup time or technical friction.</p><p>As a producer and multi-instrumentalist, I can slot in wherever a project needs me—drums, guitars, keys, arrangements, or simply steering the session. Clients come back because they get a room that sounds great, a process that respects their time and budget, and a collaborator who cares about both the emotional storytelling of a recording and the technical details that make it translate.</p><p>In the next few years, I plan to deepen Strangeways as a home for ambitious independent records while returning more fully to composing for film and television. If you sometimes feel like you’re dancing to music no one else can hear, we should talk. You’ll feel at home here.</p>",
}

export const aboutGallery: Gallery[] = [
    {
        id: "ampeg-svt-cl",
        title: "",
        caption: ""
    },
        {
        id: "anunnaki-band",
        title: "",
        caption: ""
    },
        {
        id: "boomshack-band",
        title: "",
        caption: ""
    },
        {
        id: "close-talker-bent-knee-courtney-swain-liz-fohl",
        title: "",
        caption: ""
    },
        {
        id: "maverick-cinema-2",
        title: "",
        caption: ""
    },
        {
        id: "maverick-cinema-3",
        title: "",
        caption: ""
    },
        {
        id: "maverick-cinema-band",
        title: "",
        caption: ""
    },
        {
        id: "music-hall-band-2",
        title: "",
        caption: ""
    },
        {
        id: "music-hall-band-erik-virtanen",
        title: "",
        caption: ""
    },
        {
        id: "music-hall-band",
        title: "",
        caption: ""
    },
        {
        id: "soundtracs-solitaire",
        title: "",
        caption: ""
    },
        {
        id: "strangeways-studios-2",
        title: "",
        caption: ""
    },
        {
        id: "strangeways-studios",
        title: "",
        caption: ""
    },
        {
        id: "third-zoo-band-2",
        title: "",
        caption: ""
    },
        {
        id: "third-zoo-band",
        title: "",
        caption: ""
    },
        {
        id: "tiger-mountain-2015",
        title: "",
        caption: ""
    },
        {
        id: "tiger-mountain-ben-wylie",
        title: "",
        caption: ""
    },
        {
        id: "tiger-mountain-studios-2",
        title: "",
        caption: ""
    },
        {
        id: "tiger-mountain-studios",
        title: "",
        caption: ""
    },
        {
        id: "truth-max-frazer-alifeinbinary",
        title: "",
        caption: ""
    },
        {
        id: "valerie-ransom",
        title: "",
        caption: ""
    },
        {
        id: "wolf-parade-2",
        title: "",
        caption: ""
    },
        {
        id: "wolf-parade",
        title: "",
        caption: ""
    }
]